import styled from 'styled-components';

export const PopupContainer = styled.div`
  .gm-ant-picker-dropdown.minute-disabled [data-type='minute'] li > div {
    color: rgb(0 0 0 / 25%);
    background: transparent;
    cursor: not-allowed;
  }
`;

export const ExtraContainer = styled.div`
  padding: 12px 4px;
  line-height: initial;
`;

export const Bold = styled.span`
  font-weight: 600;
`;
